import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';

const hasLanguageChanged = () => {
    let optionState = getRegionalOptions();
    let { SessionSettings } = getUserConfiguration();
    return (
        optionState.selectedLocale !== null &&
        optionState.selectedLocale !== SessionSettings.UserCulture
    );
};

export default hasLanguageChanged;
